import React from 'react';
import styled from 'styled-components';
import FormatSettingForm from './FormatSettingForm';
import * as SettingsUI from '../SettingsUI';
import { theme } from '../../../../styles/theme';

const Description = styled.div`
  margin-top: 8px;
  font-size: 12px;
  font-weight: 500;
  color: ${theme.colors.secondary800};
`;

const FormatSetting = () => {
  return (
    <SettingsUI.SettingsSection>
      <SettingsUI.Title>Formatting</SettingsUI.Title>
      <Description>
        The following format settings are organizational settings and will
        impact all users.
      </Description>
      <FormatSettingForm />
    </SettingsUI.SettingsSection>
  );
};
export default FormatSetting;
